import {
  checkMaterialOption,
  IObject,
  IProduct,
  ISelectObjectOptions,
  optionObjectOptionT,
} from "../redux/reducers/ui/uiTypes";
import { IOptionDataRequest } from "./api/3d/type";

export class ObjectService {
  public static formattedObjectData(
    objects: IObject[],
    parent: IObject | null = null
  ): IObject[] {
    if (!objects || !Array.isArray(objects)) {
      return [];
    }

    return objects.map(object => {
      const newChildren: IObject = {
        ...object,
        parent: parent ? { ...parent } : undefined,
      };

      if (newChildren.children && Array.isArray(newChildren.children)) {
        newChildren.children = ObjectService.formattedObjectData(
          newChildren.children,
          newChildren
        );
      } else {
        newChildren.children = [];
      }

      return newChildren;
    });
  }

  /**
   *
   * @description get formatted options by product and select data
   * @param type - type of options, either "material" or "geometry"
   */
  public static getOptionsByProductAndSelectData(
    type: optionObjectOptionT,
    product: IProduct,
    selectMaterialOptions: ISelectObjectOptions
  ): IOptionDataRequest[] {
    if (!product || !selectMaterialOptions) {
      return [];
    }

    const allOptions: any[] =
      type === "material"
        ? product.availableOptions
        : product.availableGeometryOptions;

    const resOptions: IOptionDataRequest[] = [];
    for (const [proxyId, options] of Object.entries<any>(
      selectMaterialOptions
    )) {
      const proxy = allOptions.find(proxy => proxy.id === parseInt(proxyId));
      if (!proxy) continue;

      for (const [optionId, variantId] of Object.entries<number>(options)) {
        const option = proxy.options.find(
          (opt: any) => opt.id === parseInt(optionId)
        );

        if (!option) continue;

        const variant = option.variants.find((v: any) => v.id === variantId);

        if (!variant) continue;

        const obj: IOptionDataRequest = {
          name: option.name,
          layerOrder: proxy.layerOrder,
          shadow: proxy.shadow,
          shadowEnabled: proxy.shadowEnabled,
          proxyName: proxy.proxyName,
          proxyType: type,
          type: type,
          paramString: option.paramString,
          dependencies: proxy.dependencies,
          requirements: [],
          proxyOptionId: proxy.id,
          optionId: option.id,
          val: variant.id,
          valName: variant.name,
          resourceUrl:
            type === "material" && checkMaterialOption(option)
              ? option.resource || null
              : null,
        };

        resOptions.push(obj);
      }
    }
    return resOptions;
  }

  static getEnabledObjectOptions = (options: any[]): any[] => {
    return options.filter((option: any) => option.enabled);
  };

  static getMultiplyEnabledObjectOptions = (options: any[]): any[] => {
    return options.flatMap((option: any) =>
      option.variants.filter((variant: any) => variant.enabled)
    );
  };

  static getAvailableVariants = (variants: any[]): any[] => {
    // These are already projects, so filter by studio property directly
    return variants.filter(item => item.studio === true);
  };
}
